module.exports = __webpack_public_path__ + "img/palladiumWhitegold.4d3d097.jpg";